// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2xrze","unreadBadge":"styles_unreadBadge__201uS","modalContent":"styles_modalContent__1lRPp","modal":"styles_modal__28_Cf"};